import { useRef } from "react"
import { Button } from "@planningcenter/doxy-web"
import {
  ChurchCenterCustomFieldApiRecordWithRelationships,
  UpdateCustomFieldAttribute,
} from "source/myChurchCenter/Profile/types"
import { Icon } from "source/shared/components"

export function File({
  customField,
  updateAttribute,
}: {
  customField: ChurchCenterCustomFieldApiRecordWithRelationships
  updateAttribute: UpdateCustomFieldAttribute
}) {
  const fieldName =
    customField.relationships.field_definition.data.attributes.name
  const fieldValue =
    customField.relationships.field_data?.data[0]?.attributes?.value
  const {
    attributes: { editing_rules: editingRules },
  } = customField

  const valueRef = useRef(fieldValue)

  const disabled =
    editingRules === "view" ||
    !!(editingRules === "add_if_blank" && valueRef.current)
  return (
    <div key={customField.id} className="mb-2">
      <div className="d-f">
        <label htmlFor={fieldName}>{fieldName}</label>
        {disabled && <Icon symbol="general#lock" className="fs-2 pl-1 pt-1" />}
      </div>
      <Button
        disabled={disabled}
        text="Choose a file"
        size="sm"
        variant="outline"
        onClick={(_e) =>
          updateAttribute({
            customField,
            record: customField.relationships.field_data?.data[0] || null,
            attribute: "value",
            value: "", // Placeholder for next PR
          })
        }
        type="button"
      />
    </div>
  )
}
